import { create } from "zustand";
import { devtools, persist } from "zustand/middleware";
import { immer } from "zustand/middleware/immer";
import { apiEnvironment } from "../config/publicConfig";
import { AppState } from "../types/types";

export const useAppStore = create<AppState>()(
  devtools(
    immer<AppState>((set, get) => ({
      loading: true,
      isLogged: false,
      licenseChecked: false,
      currentUser: null,
      currentSite: null,
      sites: null,
      envoriment: apiEnvironment,
      equipments: null,
      producers: null,
      persons: [],
      posts: [],
      router: null,
      shifts: [],
      currentShift: null,
      currentScreen: null,
      divisions: [],
      devices: [],
      triggers: [],
      screens: [],
      reports: [],
      equipmentsTime: [],
      equipmentModels: [],
      equipmentTypes: null,
      currentDivision: null,
      currentEquipment: null,
      theme: 'light',
    setPath: (path) => set((state) => {state.router = path}),
    setIsLogged: (value) => set((state) => { state.isLogged = value }),
    setLoading: (value) => set((state) => { state.loading = value }),
    setLicenseCheck: (value) => set((state) => { state.licenseChecked = value}),
    setCurrentUser: (user) => set((state) => { state.currentUser = user }),
    setLocale: (locale) => set((state) => {state.currentUser!.attributes!.locale! = locale}),
    setCurrentSite: (site) => set((state) => {
        state.currentSite = site;
        state.loading = false;
    }),
    setShifts: (shifts) => set((state) => {state.shifts = shifts}),
    setCurrentShift: (shift) => set((state) => { state.currentShift = shift }),
    setCurrentScreen: (screen) => set((state) => { state.currentScreen = screen }),
    setDivisions: (divisions) => set((state) => { state.divisions = divisions }),
    setDevices: (devices) => set((state) => {state.devices = devices}),
    setTriggers: (triggers) => set((state) => {state.triggers = triggers}),
    setScreens: (screens) => set((state) => {state.screens = screens}),
    setReports: (reports) => set((state) => {state.reports = reports}),
    setCurrentDivision: (division) => set((state) => {state.currentDivision = division}),
    setEquipments: (equipments) => set((state) => { state.equipments = equipments }),
    setProducers: (producers) => set((state) => { state.producers = producers }),
    setPersons: (persons) => set((state) => { state.persons = persons }),
    setPosts: (posts) => set((state) => {state.posts = posts}),
    setEquipmentsTime: (equipmentsTime) => set((state) => { state.equipmentsTime = equipmentsTime }),
    setEquipmentModels: (equipmentModels) => set((state) => { state.equipmentModels = equipmentModels }),
    setEquipmentTypes: (equipmentTypes) => set((state) => {state.equipmentTypes = equipmentTypes}),
    setCurrentEquipment: (equipment) => set((state) => { state.currentEquipment = equipment }),
    setTheme: (theme) => set((state) => { state.theme = theme }),
    resetStore: () => (
      set((state) => {state.isLogged = false}),
      set((state) => {state.currentUser = null}),
      set((state) => {state.currentSite = null}),
      set((state) => {state.sites = null}),
      set((state) => {state.equipments = null }),
      set((state) => {state.producers = null}),
      set((state) => {state.persons = [] }),
      set((state) => {state.posts = []}),
      set((state) => {state.equipmentsTime = []}),
      set((state) => {state.equipmentModels = []}),
      set((state) => {state.equipmentTypes = null}),
      set((state) => {state.router = null}),
      set((state) => {state.shifts = []}),
      set((state) => {state.currentShift = null}),
      set((state) => {state.currentScreen = null}),
      set((state) => {state.divisions = [] }),
      set((state) => {state.devices = [] }),
      set((state) => {state.currentDivision = null}),
      set((state) => {state.screens = []}),
      set((state) => {state.reports = []})
    )
  }))
  )
);
